import { render, staticRenderFns } from "./ProductCardGridView.vue?vue&type=template&id=674bdd0d&"
import script from "./ProductCardGridView.vue?vue&type=script&lang=js&"
export * from "./ProductCardGridView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports